module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/fluent-app-icon-10.acd81dd0.png";